export default "__VITE_ASSET__CSGHe2_G__"